/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Pss } from './Pss';
import {
    PssFromJSON,
    PssFromJSONTyped,
    PssToJSON,
} from './Pss';

/**
 * 
 * @export
 * @interface GetPss200Response
 */
export interface GetPss200Response {
    /**
     * 
     * @type {Array<Pss>}
     * @memberof GetPss200Response
     */
    records?: Array<Pss>;
}

/**
 * Check if a given object implements the GetPss200Response interface.
 */
export function instanceOfGetPss200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetPss200ResponseFromJSON(json: any): GetPss200Response {
    return GetPss200ResponseFromJSONTyped(json, false);
}

export function GetPss200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPss200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'records': !exists(json, 'records') ? undefined : ((json['records'] as Array<any>).map(PssFromJSON)),
    };
}

export function GetPss200ResponseToJSON(value?: GetPss200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'records': value.records === undefined ? undefined : ((value.records as Array<any>).map(PssToJSON)),
    };
}

